import { BrowserRouting } from '@aipb/gulliver/browser/routing';
import { NibbleAction } from '@aipb/gulliver/personal-content/model';
import { openUrl } from '@aipb/shared/util/routing';
import { NibbleActionHandler } from '../nibble-action.handler';

export class Img3ifNibbleActionHandler implements NibbleActionHandler {
  constructor(private browserRouting: BrowserRouting) {}

  handle(nibbleAction: NibbleAction) {
    const serviceValue = nibbleAction.nibbleCut.cut.serviceValue;

    const service = nibbleAction.nibbleCut.cut.serviceRaw.relatedServices.find((rs) => rs.service === 'document3if');
    const manifestUrl = service.properties.serviceValue;

    const url = this.browserRouting.detailDefaultAbsUrl(manifestUrl, serviceValue);
    openUrl(url);
  }

  getUrl(nibbleAction: NibbleAction): string {
    const serviceValue = nibbleAction.nibbleCut.cut.serviceValue;

    const service = nibbleAction.nibbleCut.cut.serviceRaw.relatedServices.find((rs) => rs.service === 'document3if');
    const manifestUrl = service.properties.serviceValue;

    return this.browserRouting.detailDefaultAbsUrl(manifestUrl, serviceValue);
  }

  useResolver(): boolean {
    return true;
  }
}
